import loadable from '@loadable/component';

export const CriteoAnalytics = loadable(
  () =>
    import(
      /* webpackChunkName: "client-only" */ '../../analytics/CriteoAnalytics'
    ),
  {
    ssr: false,
  }
);

export const FacebookPixel = loadable(
  () =>
    import(
      /* webpackChunkName: "client-only" */ '../../analytics/FacebookPixel'
    ),
  {
    ssr: false,
  }
);

export const Giosg = loadable(
  () => import(/* webpackChunkName: "client-only" */ '../../analytics/Giosg'),
  {
    ssr: false,
  }
);

export const YotpoReviewWrapper = loadable(
  () =>
    import(
      /* webpackChunkName: "client-only" */ '../../components/review/YotpoReviewWrapper'
    ),
  {
    ssr: false,
  }
);

export const SpotmoreWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "client-only" */ '../../components/marketing/SpotmoreWidget'
    ),
  {
    ssr: false,
  }
);

export const PostAffiliateWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "client-only" */ '../../integrations/postaffiliate/PostAffiliateWidget'
    ),
  {
    ssr: false,
  }
);

export const CookieNotice = loadable(
  () =>
    import(
      /* webpackChunkName: "client-only" */ '../../components/cookie-notice/CookieNotice'
    ),
  {
    ssr: false,
  }
);

export const TimerCoupons = loadable(
  () =>
    import(
      /* webpackChunkName: "client-only" */ '../../components/coupon/TimerCoupons'
    ),
  {
    ssr: false,
  }
);

export const ActivatedCoupons = loadable(
  () =>
    import(
      /* webpackChunkName: "client-only" */ '../../components/coupon/ActivatedCoupons'
    ),
  {
    ssr: false,
  }
);

export const TimerMessage = loadable(
  () =>
    import(
      /* webpackChunkName: "client-only" */ '../../components/common/TimerMessage'
    ),
  {
    ssr: false,
  }
);

export const RedirectModal = loadable(
  () =>
    import(
      /* webpackChunkName: "client-only" */ '../../components/localization/RedirectModal'
    ),
  {
    ssr: false,
  }
);

export const SurveyModal = loadable(
  () =>
    import(
      /* webpackChunkName: "client-only" */ '../../components/surveys/SurveyModal'
    ),
  {
    ssr: false,
  }
);

export const RecaptchaField = loadable(
  () =>
    import(
      /* webpackChunkName: "client-only" */ '../../components/form/RecaptchaField'
    ),
  {
    ssr: false,
  }
);

export const UniversalJavascriptTool = loadable(
  () =>
    import(
      /* webpackChunkName: "client-only" */ '../../components/common/UniversalJavascriptTool'
    ),
  {
    ssr: false,
  }
);

export const ServiceFormWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "client-only" */ '../../integrations/serviceForm/ServiceFormWidget'
    ),
  {
    ssr: false,
  }
);
